module.exports = __webpack_public_path__ + "img/more-menu.17fc1a6d.svg";